import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IStyleProps {
  small?: boolean
  green?: boolean
  secondary?: boolean
  disabled?: boolean
}

export const Label = styled.label`
  display: flex;

  width: 252px;
  height: 114px;

  border-radius: 5px;
  background: ${Theme.pallete.SECONDARY};

  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.25);

  .resume-card-picture-container-right {
    display: flex;
    justify-content: flex-end;

    width: 45%;
  }

  .resume-card-picture-container-left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    padding: 17px 0px 16px 20px;

    width: 55%;
    @media only screen and (min-width: 1441px) {
      padding: 20px 0px 18px 21px;
    }
  }

  .resume-card-picture-img {
    position: relative;
    top: 8px;
    left: 0;
    margin-right: 12px;

    background-color: ${Theme.pallete.SECONDARY3};

    border: solid 10.2px ${Theme.pallete.SECONDARY3};
    height: 100px;
    border-radius: 10px;
    @media only screen and (min-width: 1441px) {
      height: 112px;
    }
  }

  .resume-card-picture-icon {
    width: 19px;
    height: 19px;
    @media only screen and (min-width: 1441px) {
      height: 21px;
      width: 21px;
    }
  }

  .resume-card-span {
    color: ${Theme.pallete.PRIMARY3};
    font-family: ${Theme.fontFamily.PRIMARY};
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.16px;
    @media only screen and (min-width: 1441px) {
      font-size: 15px;
    }
  }

  .resume-card-input {
    display: none;
  }
  @media only screen and (min-width: 1441px) {
    height: 128px;
    width: 284px;
  }
`
